import React from 'react';
import { connect } from 'react-redux';
import classes from './LoginView.scss';
import api from '../../../utils/api';

import Paper from 'material-ui/Paper';
import { Tab, Tabs } from 'material-ui/Tabs';

import LoginForm from './LoginForm';
import ResetPasswordForm from './ResetPasswordForm';
import { detect } from 'detect-browser';

const browser = detect();

class LoginView extends React.Component {
    onSubmit = values => {
        const newValues = Object.assign({}, values.toJS(), {
            endpointPrefix: values.get('endpointPrefix').toLowerCase(),
        });
        this.props.login(newValues);
    };

    onSubmitResetPasswordForm = values => {
        values = values.toJS();
        values.endpointPrefix = values.endpointPrefix.toLowerCase();
        this.props.resetPassword(values);
    };

    invalidContent = () => {
        return (
            <div style={{ padding: '40px', textAlign: 'center' }}>
                Diese Seite ist nur kompatibel mit{' '}
                <a href="https://www.google.de/chrome/browser/desktop/">Chrome</a> oder{' '}
                <a href="https://www.mozilla.org/de/firefox/new/">Firefox</a>.
            </div>
        );
    };

    renderContent = () => {
        return (
            <div className="content">
                <Tabs>
                    <Tab label="Anmeldung">
                        <div>
                            <LoginForm onSubmit={this.onSubmit} />
                        </div>
                    </Tab>
                    <Tab label="Passwort zurücksetzen">
                        <div>
                            <ResetPasswordForm
                                onSubmit={this.onSubmitResetPasswordForm}
                                isLoading={this.props.isFetching}
                            />
                        </div>
                    </Tab>
                </Tabs>
            </div>
        );
    };

    render = () => {
        const validBrowser = browser.name === 'chrome' || browser.name === 'firefox';

        return (
            <div className={classes.container}>
                <Paper zDepth={1}>
                    {validBrowser && this.renderContent()}
                    {!validBrowser && this.invalidContent()}
                </Paper>
            </div>
        );
    };
}

const mapStateToProps = (state, props) => ({
    isFetching: state.auth.get('isFetching'),
});

const mapDispatchToProps = dispatch => ({
    login: payload => dispatch(api.actions.auth.loginUser(payload)),
    resetPassword: payload => dispatch(api.actions.auth.resetPassword(payload)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginView);
